import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {GeneralFormComponent} from '../../general/form/generalForm.component';
import {MessageService} from '../../../../shared/message.service';
import {QuestionService} from '../../../services/question.service';
import {QuestionControlService} from '../../../services/question-control.service';
import {UserRightGroupService} from '../../../services/user-group-right.service';
import {UserRightGroup} from '../../../interfaces/userRightGroup';

@Component({
  selector: 'qm-user-group-details',
  templateUrl: '../../general/form/generalForm.component.html',
  styleUrls: ['../../general/form/generalForm.component.css']
})
export class UserRightGroupFormComponent extends GeneralFormComponent<UserRightGroup> {

  constructor(
    route: ActivatedRoute,
    location: Location,
    messagesService: MessageService,
    router: Router,
    questionService: QuestionService,
    userRightGroupService: UserRightGroupService,
    questionControlService: QuestionControlService
  ) {
    super(route, userRightGroupService, location, messagesService, router, questionService, questionControlService,
      {
        entityNameSingular: 'group right',
        entityNamePlural: 'group rights',
        formUrl: 'groupright',
        listUrl: 'grouprights',
        generalFormMetaName: 'user-right-group'
      });
  }
}
